<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'Umowy'" [name]="'Lista'"></app-breadcrumb>
<div class="contract-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="contract-list-filters">
    <mat-form-field class="contract-list-filter">
      <mat-label>ID</mat-label>
      <input matInput placeholder="12345" name="recordId" [(ngModel)]="initialFilters.recordId">
    </mat-form-field>

    <app-dict
      [multiple]="true" [dictType]="'contract_type'"
      [label]="'Rodzaj'" class="contract-list-filter"
      [(ngModel)]="initialFilters.type" name="type"
    ></app-dict>

    <app-datepicker
      class="contract-list-filter"
      label="Data zawarcia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$concludeDate" name="gte$concludeDate"
    ></app-datepicker>

    <app-datepicker
      class="contract-list-filter"
      label="Data zawarcia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$concludeDate" name="lte$concludeDate"
    ></app-datepicker>

    <app-dict
      [multiple]="false" [dictType]="'company'"
      [label]="'Firma'" class="contract-list-filter"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <app-dict
      [multiple]="true" [dictType]="'contract_status'"
      [label]="'Status'" class="contract-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <mat-form-field class="contract-list-filter">
      <mat-label>Numer</mat-label>
      <input matInput placeholder="12345" name="contains$number" [(ngModel)]="initialFilters.contains$number">
    </mat-form-field>

    <app-datepicker
      class="contract-list-filter"
      label="Aktywna od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$activeFrom" name="gte$activeFrom"
    ></app-datepicker>

    <app-datepicker
      class="contract-list-filter"
      label="Aktywna do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$activeFrom" name="lte$activeFrom"
    ></app-datepicker>

    <app-datepicker
      class="contract-list-filter"
      label="Data zakończenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$activeTo" name="gte$activeTo"
    ></app-datepicker>

    <app-datepicker
      class="contract-list-filter"
      label="Data zakończenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$activeTo" name="lte$activeTo"
    ></app-datepicker>

    <app-dict
      [multiple]="false" [dictType]="'termination_time'"
      [label]="'Okres wypowiedzenia'" class="contract-list-filter"
      [(ngModel)]="initialFilters.terminationTime" name="terminationTime"
    ></app-dict>

    <app-dict
      [multiple]="false" [dictType]="'termination_type'"
      [label]="'Sposób rozwiązania'" class="contract-list-filter"
      [(ngModel)]="initialFilters.terminationType" name="terminationType"
    ></app-dict>

    <app-dict
      [multiple]="false" [dictType]="'contract_period'"
      [label]="'Czas trwania'" class="contract-list-filter"
      [(ngModel)]="initialFilters.period" name="period"
    ></app-dict>

    <app-dict
      [multiple]="false" [dictType]="'contract_owner'"
      [label]="'Strona umowy'" class="contract-list-filter"
      [(ngModel)]="initialFilters.owner" name="owner"
    ></app-dict>

    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="contract-list-filter contract-list-filter-long"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="contract-list-filter contract-list-filter-long"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-dict-regionals
      [multiple]="false" [label]="'Regionalny (majątek)'"
      class="contract-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <mat-form-field appearance="standard" class="contract-list-filter">
      <mat-label>Rekord zweryfikowany</mat-label>
      <mat-select [(ngModel)]="initialFilters.verified" name="verified">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

<!--    <mat-form-field appearance="standard" class="contract-list-filter">-->
<!--      <mat-label>Aktualne zgłoszenie</mat-label>-->
<!--      <mat-select [(ngModel)]="initialFilters.signedCurrentApplications" name="signedCurrentApplications">-->
<!--        <mat-option [value]="null">Wszystkie</mat-option>-->
<!--        <mat-option [value]="1">Tak</mat-option>-->
<!--        <mat-option [value]="0">Nie</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <mat-form-field appearance="standard" class="contract-list-filter">
      <mat-label>Nowy wzór umowy</mat-label>
      <mat-select [(ngModel)]="initialFilters.newContractTemplate" name="newContractTemplate">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="contract-list-filter">
      <mat-label>Automatyczne rozliczanie</mat-label>
      <mat-select [(ngModel)]="initialFilters.automaticBilling" name="automaticBilling">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="contract-list-filter">
      <mat-label>Niestandardowe zapisy w umowie</mat-label>
      <mat-select [(ngModel)]="initialFilters.customTerms" name="customTerms">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="contract-list-filter">
      <mat-label>Oczekuje</mat-label>
      <mat-select [(ngModel)]="initialFilters.selfBillingExpects" name="selfBillingExpects">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div class="contract-list-buttons">
    <button *ngIf="(userPermissions | async).contract.read_report" [disabled]="!(userPermissions | async).contract.read_report"
            mat-raised-button [matMenuTriggerFor]="generate" class="report-button">
      <mat-icon>download</mat-icon> Pobierz raport</button>
    <mat-menu #generate="matMenu">
      <button *ngIf="(userPermissions | async).contract.read_report" [disabled]="!(userPermissions | async).contract.read_report"  mat-menu-item (click)="downloadReport()">Pobierz raport pełny</button>
      <button *ngIf="(userPermissions | async).contract.read_report" [disabled]="!(userPermissions | async).contract.read_report" mat-menu-item (click)="openReportDialog()">Pobierz raport niestandardowy</button>
    </mat-menu>

    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="contracts">

    <!-- Position Column -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Rodzaj</th>
      <td mat-cell *matCellDef="let element">
        {{element.type?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="concludeDate">
      <th mat-header-cell *matHeaderCellDef> Data zawarcia</th>
      <td mat-cell *matCellDef="let element">
        {{element.concludeDate | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma</th>
      <td mat-cell *matCellDef="let element">
        {{element.company?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="terminationReason">
      <th mat-header-cell *matHeaderCellDef> Powód rozwiązania </th>
      <td mat-cell *matCellDef="let element">
        {{element.terminationReason}}
      </td>
    </ng-container>

    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef> Numer</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/umowy/szczegoly', element.uuid]">{{element.number}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="activeTo">
      <th mat-header-cell *matHeaderCellDef> Data zakończenia</th>
      <td mat-cell *matCellDef="let element">
        {{element.activeTo | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="owner">
      <th mat-header-cell *matHeaderCellDef> Strona umowy</th>
      <td mat-cell *matCellDef="let element">
        {{element.owner?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="party">
      <th mat-header-cell *matHeaderCellDef> Partner/OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner">
          <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
        </ng-container>

        <ng-container *ngIf="element.ofwca">
          <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner">
          {{element.partner.assetsRegional?.firstName}} {{element.partner.assetsRegional?.lastName}}
        </ng-container>

        <ng-container *ngIf="element.ofwca">
          {{element.ofwca.assetsRegional?.firstName}} {{element.ofwca.assetsRegional?.lastName}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).document.write" mat-menu-item (click)="addDocument(element)">Dodaj dokument</button>
<!--          <button [disabled]="!(userPermissions | async).contract.delete" mat-menu-item (click)="deleteContract(element)">Usuń</button>-->
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
